module.exports = __webpack_public_path__ + "static/media/T14-T25-02.f3cc65f1.svg";